import clsx from "clsx";
import type { ResearchJobStatus } from "@carago/shared";

const STATUS_LABELS: Record<ResearchJobStatus, string> = {
  queued: "Queued",
  running: "Running",
  cancelling: "Cancelling",
  cancelled: "Cancelled",
  completed: "Completed",
  failed: "Failed",
};

const STATUS_CLASS: Record<ResearchJobStatus, string> = {
  queued: "bg-gray-100 text-gray-700",
  running: "bg-sky-100 text-sky-800",
  cancelling: "bg-yellow-100 text-yellow-800",
  cancelled: "bg-gray-200 text-gray-600",
  completed: "bg-green-100 text-green-800",
  failed: "bg-red-100 text-red-800",
};

type JobStatusBadgeProps = {
  status: ResearchJobStatus;
};

export function JobStatusBadge({ status }: JobStatusBadgeProps) {
  return (
    <span
      className={clsx(
        "inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        STATUS_CLASS[status],
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
